import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import download from "downloadjs";

import { API_ROOT } from "../../../api/constants";

import BaseFormContainer from "../../common/components/form/BaseFormContainer";

import * as channelActions from "../../channel/channel.actions";
import { getAllChannels } from "../../channel/channel.selectors";
import TransactionsExportForm from "./TransactionsExportForm";
import { Localize } from "../../../locale/localization";

const constraints = {
  channel: {
    presence: {
      message: `^${Localize("form.transactions-export.channel.error")}`
    }
  }
};

class TransactionsExportFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      channel: "_all_"
    };

    this.state = {
      ...this.state,
      formData,
      isValid: true
    };
  }

  componentWillMount = () => {
    const { getChannels } = this.props;

    getChannels();
  };

  getConstraints = () => constraints;

  doSubmit = formData => {
    const channel = formData.channel;
    const token = localStorage.getItem("cmore-sisapiiri-token");
    const url =
      channel === "_all_"
        ? `${API_ROOT}api/transaction/export`
        : `${API_ROOT}api/transaction/export?channelId=${channel}`;
    const init = {
      method: "POST",
      headers: new Headers({
        authtoken: `${token}`
      })
    };

    fetch(url, init)
      .then(resp => {
        return resp.blob();
      })
      .then(blob => {
        download(blob);
        this.setState({
          isSubmitting: false
        });
      });
  };

  onCancel = event => {
    event.preventDefault();

    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  };

  render() {
    const { channels } = this.props;

    return (
      <TransactionsExportForm
        enabled={!this.state.isSubmitting}
        onSubmit={this.onSubmit}
        onCancel={this.onCancel}
        onInputChange={this.onInputChange}
        onBlur={this.onBlur}
        errors={this.state.errors}
        touchedFields={this.state.touchedFields}
        isValid={this.state.isValid}
        channel={this.state.formData.channel}
        channels={channels}
      />
    );
  }
}

const mapStateToProps = (state, { cancelPath }) => {
  const channels = getAllChannels(state);
  return {
    cancelPath,
    channels
  };
};

const ConnectedTransactionsExportFormContainer = connect(mapStateToProps, channelActions)(
  TransactionsExportFormContainer
);

export default withRouter(ConnectedTransactionsExportFormContainer);



// WEBPACK FOOTER //
// ./src/modules/transaction/components/TransactionsExportFormContainer.js